// ViewMemberModal.jsx
import React, { useEffect, useMemo, useState } from 'react';
import ReactModal from 'react-modal';
import "../popups.css";
import './viewModal.css';
import { getApi } from '../Services/apiService';
import { enums } from '../constants/enums';
import { getGenerationName, getViewFirstSubheading } from '../Utils/generation';
import { formatFullName } from '../Utils/familyRelations';
import { formatPhoneNumber } from '../Utils/phone';
import { normalizeRelation } from '../Utils/normalizeRelation';
import { formatNameWithSuffix } from '../Utils/name';
import { formatMsToMMDDYYYY } from '../Utils/dateUtils';

const ViewMemberModal = ({
    isOpen,
    onClose,
    memberData,
    isRootGeneration,
    primaryLabel,
    spouseLabel,
    onEdit,
    treeData,
    setMemberData
}) => {

    const [data, setData] = useState({});
    // Set the app element for accessibility
    if (process.env.NODE_ENV !== 'test') {
        ReactModal.setAppElement('#root');
    }

    // console.log("member data in view modal : ", memberData);
    // console.log("member data USER", data.User)

    // Format date for display
    // const formatDate = (timestamp) => {
    //     if (!timestamp) return '-';
    //     const date = new Date(timestamp);
    //     return date.toLocaleDateString('en-US', {
    //         year: 'numeric',
    //         month: 'short',
    //         day: 'numeric'
    //     });
    // };
    const msToDate = (ms) => formatMsToMMDDYYYY(ms) || "-";

    function hexToRgb(hex) {
        hex = hex.replace("#", "");
        if (hex.length === 3) {
            hex = hex.split("").map(c => c + c).join("");
        }
        const bigint = parseInt(hex, 16);
        const r = (bigint >> 16) & 255;
        const g = (bigint >> 8) & 255;
        const b = bigint & 255;
        return `${r}, ${g}, ${b}`;
    }

    // Format phone number with country code
    const formatPhone = (phone, countryCode) => {
        if (!phone) return '-';
        return countryCode ? `${countryCode} ${phone}` : phone;
    };

    const fetchMemberData = async () => {
        try {
            const response = await getApi(`/family-member-v2/${memberData?.id}`);
            console.log("response ======== ", response)
            setData(response.data);
            // setMemberData(prev => ({ ...prev, relation_to_head_of_line: response.data.relation_to_head_of_line }));
        } catch (error) {
            console.error('Error fetching member data:', error);
        }
    };



    // Recursive search in treeData
    const findById = (nodes, id) => {
        if (!Array.isArray(nodes) || !id) return null;
        for (const node of nodes) {
            if (node?.id === id) return node;
            const found = findById(node?.children, id);
            if (found) return found;
        }
        return null;
    };

    // Inside your component
    const parentNode = useMemo(() => {
        const parentId = memberData?.related_member_id;
        return parentId ? findById(treeData, parentId) : null;
    }, [treeData, memberData?.related_member_id]);

    const parentInfo = useMemo(() => {
        if (!parentNode) return null;

        const name =
            parentNode.full_name ||
            formatNameWithSuffix(
                parentNode.first_name,
                parentNode.middle_name,
                parentNode.last_name,
                parentNode.suffix
            ) ||
            "-";

        const spouseName =
            parentNode.spouse_full_name ||
            parentNode.spouse_first_name ||
            "-";

        return {
            parentName: name,
            parentImage: parentNode.image || null,
            spouseName,
            spouseImage: parentNode.spouse_image || null,
        };
    }, [parentNode]);

    // Debug (optional)
    // console.log("Resolved parentInfo:", parentInfo);

    // Get the full parent name from parentInfo if available (includes middle name)
    // This ensures we have "Sanjeev Das Mital" instead of just "Sanjeev"
    const fullParentName = useMemo(() => {
        if (parentInfo?.parentName && parentInfo.parentName !== "-") {
            return parentInfo.parentName;
        }
        return data?.parent_name || memberData?.parent_name || "";
    }, [parentInfo?.parentName, data?.parent_name, memberData?.parent_name]);

    // Get generation level - use data from API if available, otherwise use memberData
    const generationLevel = useMemo(() => {
        return data?.generation_level || memberData?.generation_level;
    }, [data?.generation_level, memberData?.generation_level]);

    // Get first name - use data from API if available, otherwise use memberData
    const firstName = useMemo(() => {
        return data?.first_name || memberData?.firstName || memberData?.first_name || "";
    }, [data?.first_name, memberData?.firstName, memberData?.first_name]);

    useEffect(() => {
        if (memberData?.id) {
            fetchMemberData();
        }
    }, [memberData]);
    // console.log("View member modal opened")
    // console.log("===========================================================")
    // console.log("isOpen", isOpen)
    // console.log("memberData in view modal", memberData)
    // console.log("treeData", treeData)
    // console.log("isRootGeneration", isRootGeneration)
    // console.log("primaryLabel", primaryLabel)
    // console.log("spouseLabel", spouseLabel)
    // console.log("===========================================================")
    return (
        <ReactModal
            isOpen={isOpen}
            onRequestClose={onClose}
            //   className="modal-content addmember-popup"
            //   overlayClassName="modal-overlay"
            className="popup-card addmember-card"
            overlayClassName="popup-overlay addmember-overlay"
            closeTimeoutMS={200}
            ariaHideApp={false}
        >
            <div className="popup-header addmember-header"
                style={{ backgroundColor: memberData?.colorCode || '#A6A6B5' }}
            >
                <div className="header-left">
                    <div className="">

                        <div className="">

                            <svg fill="white"
                                width="40px"
                                height="40px"
                                viewBox="0 0 24 24" version="1.2" baseProfile="tiny" xmlns="http://www.w3.org/2000/svg"><path d="M21.821 12.43c-.083-.119-2.062-2.944-4.793-4.875-1.416-1.003-3.202-1.555-5.028-1.555-1.825 0-3.611.552-5.03 1.555-2.731 1.931-4.708 4.756-4.791 4.875-.238.343-.238.798 0 1.141.083.119 2.06 2.944 4.791 4.875 1.419 1.002 3.205 1.554 5.03 1.554 1.826 0 3.612-.552 5.028-1.555 2.731-1.931 4.71-4.756 4.793-4.875.239-.342.239-.798 0-1.14zm-9.821 4.07c-1.934 0-3.5-1.57-3.5-3.5 0-1.934 1.566-3.5 3.5-3.5 1.93 0 3.5 1.566 3.5 3.5 0 1.93-1.57 3.5-3.5 3.5zM14 13c0 1.102-.898 2-2 2-1.105 0-2-.898-2-2 0-1.105.895-2 2-2 1.102 0 2 .895 2 2z" />
                            </svg>

                        </div>

                    </div>
                    <div>
                        <h2 style={{ color: "white" }}>
                            View Family Member Info for {memberData?.firstName || data?.first_name} {memberData?.lastName || data?.last_name}{data?.suffix || memberData?.suffix ? `, ${data?.suffix || memberData?.suffix}.` : ''}
                        </h2>
                        {/* <p>Viewing member info for</p> */}
                    </div>
                </div>
                <button onClick={onClose} className="close-button"
                    style={{
                        position: 'absolute',
                        top: '10px',
                        right: '10px',
                        background: 'transparent',
                        border: 'none',
                        fontSize: '24px',
                        cursor: 'pointer',
                        color: '#fff',
                        zIndex: 10
                    }}
                >×</button>
            </div>




            {/* Add this right after the header closing tag (after the close button) */}
            <div className="view-member-bio-section">
                {/* Bio Description */}
                {/* <div className="view-member-subheading-text"
                    style={{
                        // marginBottom: '20px',
                        // paddingBottom: '20px',
                        // borderBottom: '1px solid #eaeaea'
                    }}>
                    <p>
                        {memberData.firstName || 'grandpa'} & {memberData.spouseFirstName || 'grandma'}
                    </p>

                    <p>Top of line</p>
                    <p>Family/Line Color</p>
                    <p>Relation to Top of Line</p>

                </div> */}
                <div className={`view-member-subheading-text ${(data?.parent) ? "" : ""}`}>

                    {
                        // (data?.parent) ? (<div className='text-cener'>
                        //     <label>
                        //         {/* {parentInfo.parentName} */}
                        //         Bio Desc & NonDesc Bio Parents
                        //     </label>
                        //     <div className="view-member-subheading-cards">
                        //         <div>
                        //             <img src={data?.parent?.image  || "/assets/images/d-user.jpg"} alt="img" />
                        //             {/* <img src={data?.parent?.spouse_image  || "/assets/images/d-user.jpg"} alt="img" /> */}
                        //         </div>
                        //         {data?.parent?.first_name ||  "husband"} & {data?.parent?.spouse_first_name || "wife"}
                        //     </div>
                        // </div>
                        // ) 
                        // : 
                        // (
                        //     <>
                        //     </>
                        // )
                    }


                    <div className='text-cener'>
                        <label className='w-100 text-center'>{
                            // (data?.generation_level == 1 || data?.generation_level ==2 ) ? "Top of the Line" : "Head of the Line"

                            getViewFirstSubheading(data?.generation_level)

                        }</label>
                        <div className="view-member-subheading-cards top-of-line">
                            {(() => {
                                const generationLevel = data?.generation_level || memberData?.generation_level;
                                const rootMemberImage = (generationLevel >= 1 || memberData?.generation_level >= 1) 
                                    ? data?.root_member?.image 
                                    : data?.head_member?.image;
                                const rootMemberSpouseImage = (generationLevel >= 1 || memberData?.generation_level >= 1) 
                                    ? data?.root_member?.spouse_image 
                                    : data?.head_member?.spouse_image;
                                
                                return (
                                    <>
                                        <div className="parent">
                                            <img src={ 
                                                rootMemberImage || 
                                                window.getPublicUrl("/assets/images/dummy-user.svg")
                                            } className='grandpa' alt="main" />
                                        </div>
                                        {rootMemberSpouseImage && (
                                            <div className="child">
                                                <img src={rootMemberSpouseImage} className='grandpa' alt="spouse" />
                                            </div>
                                        )}
                                    </>
                                );
                            })()}
                            <p>
                                {/* { getGenerationName(data?.generation_level, data?.parent_name, data?.first_name, true) || "Root head" } */}
                                {(() => {
                                    const generationLevel = data?.generation_level || memberData?.generation_level;
                                    const isHeadOfLineOrBelow = generationLevel >= 2;
                                    const isGeneration1 = generationLevel === 1 || memberData?.generation_level === 1;
                                    
                                    // Helper function to clean name by removing generation level text like "(Generation 1)"
                                    const cleanName = (name) => {
                                        if (!name) return name;
                                        // Remove patterns like "(Generation 1)", "(Generation X)", etc.
                                        return name.replace(/\s*\(Generation\s+\d+\)/gi, '').trim();
                                    };
                                    
                                    // For generation 1, use root_member data (or member's own data if root_member not available)
                                    // For generation 2 and below, use root_member instead of parent
                                    const topOfLineFirstName = isGeneration1
                                        ? cleanName(data?.root_member?.first_name || data?.first_name || memberData?.data?.topOfLineData?.first_name || memberData?.first_name || memberData?.firstName)
                                        : (isHeadOfLineOrBelow 
                                            ? cleanName(data?.root_member?.first_name || memberData?.data?.topOfLineData?.first_name)
                                            : (memberData?.data?.topOfLineData?.first_name || data?.parent?.first_name));
                                    
                                    const topOfLineSpouseFirstName = isGeneration1
                                        ? cleanName(data?.root_member?.spouse_first_name || data?.spouse_first_name || memberData?.data?.topOfLineData?.spouse_first_name || memberData?.spouse_first_name || memberData?.spouseFirstName)
                                        : (isHeadOfLineOrBelow 
                                            ? cleanName(data?.root_member?.spouse_first_name || memberData?.data?.topOfLineData?.spouse_first_name)
                                            : (memberData?.data?.topOfLineData?.spouse_first_name || data?.parent?.spouse_first_name));
                                    
                                    const topOfLineLastName = isGeneration1
                                        ? (data?.root_member?.last_name || data?.last_name || memberData?.data?.topOfLineData?.last_name || memberData?.last_name || memberData?.lastName)
                                        : (isHeadOfLineOrBelow 
                                            ? (data?.root_member?.last_name || memberData?.data?.topOfLineData?.last_name)
                                            : (memberData?.data?.topOfLineData?.last_name || data?.parent?.last_name));
                                    
                                    return getGenerationName(
                                        memberData?.generation_level === 1
                                            ? memberData?.generation_level + 1
                                            : memberData?.generation_level,
                                        memberData?.parent_name,
                                        memberData?.fullName,
                                        true,
                                        (isGeneration1 || memberData?.generation_level == 2 || generationLevel > 2 ? true : false),
                                        topOfLineFirstName,
                                        topOfLineSpouseFirstName,
                                        topOfLineLastName
                                    ) || "Root head";
                                })()}



                                {/* {memberData?.data?.topOfLineData?.first_name || memberData?.data?.topOfLineData?.first_name || "Root head"}
                        { memberData?.data?.topOfLineData?.spouse_first_name && " & "+memberData?.data?.topOfLineData?.spouse_first_name } 
                        { memberData?.data?.topOfLineData?.last_name && " "+memberData?.data?.topOfLineData?.last_name} */}
                                {/* {
                                    data?.generation_level == 1
                                        ? `${memberData?.data?.topOfLineData?.first_name || "Root head"}${memberData?.data?.topOfLineData?.spouse_first_name ? " & " + memberData?.data?.topOfLineData?.spouse_first_name : ""}${memberData?.data?.topOfLineData?.last_name ? " " + memberData?.data?.topOfLineData?.last_name : ""}`
                                        : `${data?.head_member?.first_name}  ${" & " +data?.head_member?.spouse_first_name || ""} ${data?.head_member?.last_name}`
                                } */}

                                {/*getGenerationName */}
                                {/* {
                                    data?.generation_level == 1
                                        ? formatFullName(
                                            getGenerationName(data?.generation_level, data?.parent_name, data?.first_name) || "Root head",
                                            data?.spouse_first_name,
                                            data?.last_name
                                        )
                                        : formatFullName(
                                            data?.head_member?.first_name,
                                            // data?.head_member?.spouse_first_name,
                                            // data?.head_member?.last_name
                                        )
                                } */}


                            </p>

                        </div>
                    </div>
                    <div className='text-cener'>
                        <label className='w-100 text-center'>Relation to Start/Top of the Line</label>
                        {/* <label className='w-100 text-center'>{memberData?.generation_level == 1 ? "Relation to Top of the Line" : "Relation to Top of the Line"}</label> */}
                        <div className="view-member-subheading-cards">
                            {(memberData?.generation_level === 1 || data?.generation_level === 1) ? "Self" : normalizeRelation(memberData?.relation || data?.relation || "")}
                        </div>
                    </div>
                    <div className='text-cener'>
                        <label className='w-100 text-center'>
                            Head of Family Line/Color
                        </label>
                        <div className="view-member-subheading-cards">

                            <div className='button-color' style={{
                                // position: 'relative',
                                width: '215px',
                                height: '24px',
                                borderRadius: '4px',
                                textAlign: 'center',
                                backgroundColor: memberData?.colorCode
                                    ? `${memberData.colorCode.startsWith("#")
                                        ? `rgba(${hexToRgb(memberData.colorCode)}, 0.2)`
                                        : memberData.colorCode}`
                                    : "rgba(166, 166, 181, 0.5)",
                            }}>


                                <div className='dots-color-code'
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center', // space for the after dot
                                    }}
                                >
                                    {
                                        // data?.parent?.first_name || ""
                                        getGenerationName(
                                            memberData?.generation_level == 1 ? memberData?.generation_level + 1 : memberData?.generation_level,
                                            memberData?.parent_name,
                                            memberData?.fullName,
                                            false
                                            // (memberData?.generation_level ==2 ? true : false),
                                            // memberData?.data?.topOfLineData?.first_name,
                                            // memberData?.data?.topOfLineData?.spouse_first_name,
                                            // memberData?.data?.topOfLineData?.last_name)
                                        )
                                    }
                                    {" ("}
                                    <div
                                        style={{
                                            content: '""',
                                            width: '12px',
                                            height: '12px', display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            backgroundColor: memberData?.colorCode || '#A6A6B5',
                                            borderRadius: '50%',
                                        }}
                                    >
                                    </div>
                                    <span style={{ fontSize: '12px', fontWeight: '400', color: memberData?.colorCode || '#A6A6B5' }}>{data?.color_name || ''} </span>
                                    {")"}
                                    {/* This acts as ::after */}

                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>





            <div className="popup-body addmember-body">



                <div className='view-member-info-card'>
                    <div className='addmember-body-scroll'>

                        {/* Basic Info Section */}
                        <div className="view-member-info-section">

                        <div className="view-member-info-container">
                            <div className="view-member-section-title border-top-0">Primary Info</div>
                            {/* Profile Image */}
                            <div className='basic-ingo-img'>
                                {memberData.photo && (
                                    <div className="image-row addmember-image-row" style={{ marginBottom: '0' }}>
                                        <img
                                            src={memberData?.photo || window.getPublicUrl("/assets/images/dummy-user.svg")}
                                            alt="Member"
                                            style={{
                                                width: '100px',
                                                height: '100px',
                                                borderRadius: '50%',
                                                objectFit: 'cover',
                                                border: `3px solid ${memberData.colorCode || '#A6A6B5'}`
                                            }}
                                        />
                                    </div>
                                )}
                                <div className="add-photo">
                                    <label>
                                        <span>+</span>
                                        <input
                                            type="file"
                                            style={{ display: "none" }}
                                            disabled={true}
                                        />
                                    </label>
                                </div>
                            </div>

                                {/*Gender Info */}
                                <div className="view-member-info-row">
                                    <div className="view-member-info-label">Gender</div>
                                    <div className='view-member-arrow'>-</div>
                                    <div className="view-member-info-value">
                                        {enums.gender[data?.gender] || "-"}
                                    </div>
                                </div>

                                {/* Name Information */}
                                <div className="view-member-info-row">
                                    <div className="view-member-info-label">First Name</div>
                                    <div className='view-member-arrow'>-</div>
                                    <div className="view-member-info-value">
                                        {data?.first_name || '-'}
                                    </div>
                                </div>


                                <div className="view-member-info-row">
                                    <div className="view-member-info-label">Middle Name</div>
                                    <div className='view-member-arrow'>-</div>
                                    <div className="view-member-info-value">
                                        {data?.middle_name || "-"}
                                    </div>
                                </div>

                                <div className="view-member-info-row">
                                    <div className="view-member-info-label">Special Initial</div>
                                    <div className='view-member-arrow'>-</div>
                                    <div className="view-member-info-value">
                                        {data?.special_name || ""}
                                    </div>
                                </div>

                                {/*Last Name field */}
                                <div className="view-member-info-row">
                                    <div className="view-member-info-label">Last Name</div>
                                    <div className='view-member-arrow'>-</div>
                                    <div className="view-member-info-value">
                                        {data?.last_name || '-'}
                                    </div>
                                </div>



                                <div className="view-member-info-row">
                                    <div className="view-member-info-label">Suffix</div>
                                    <div className='view-member-arrow'>-</div>
                                    <div className="view-member-info-value">
                                        {data?.suffix || "-"}
                                    </div>
                                </div>



                                <div className="view-member-info-row">
                                    <div className="view-member-info-label">Maiden Name</div>
                                    <div className='view-member-arrow'>-</div>
                                    <div className="view-member-info-value">
                                        {data?.maiden_name || "-"}
                                    </div>
                                </div>

                                {/**Nick Name field*/}
                                <div className="view-member-info-row">
                                    <div className="view-member-info-label">Nickname</div>
                                    <div className='view-member-arrow'>-</div>
                                    <div className="view-member-info-value">
                                        {data?.nick_name || "-"}
                                    </div>
                                </div>


                                {/* Personal Information */}
                                <div className="view-member-section-title">Other Personal Info</div>



                                {/*Living / Deceased field */}
                                <div className="view-member-info-row">
                                    <div className="view-member-info-label">Living / Deceased</div>
                                    <div className='view-member-arrow'>-</div>
                                    <div className="view-member-info-value">
                                        {enums.present_or_deceased[data?.present_or_deceased] || "-"}
                                    </div>
                                </div>

                                {/*Martial Status field */}
                                <div className="view-member-info-row">
                                    <div className="view-member-info-label">Martial Status</div>
                                    <div className='view-member-arrow'>-</div>
                                    <div className="view-member-info-value">
                                        {enums.marital_status[data?.marital_status] || "-"}
                                    </div>
                                </div>


                                <div className="view-member-info-row">
                                    <div className="view-member-info-label">Date of Birth</div>
                                    <div className='view-member-arrow'>-</div>
                                    <div className="view-member-info-value">
                                        {msToDate(data?.dob) || "-"}
                                    </div>
                                </div>



                                <div className="view-member-info-row">
                                    <div className="view-member-info-label">State of Birth</div>
                                    <div className='view-member-arrow'>-</div>
                                    <div className="view-member-info-value">
                                        {data?.state_of_birth || "-"}
                                    </div>
                                </div>

                                <div className="view-member-info-row">
                                    <div className="view-member-info-label">Current State Residing</div>
                                    <div className='view-member-arrow'>-</div>
                                    <div className="view-member-info-value">
                                        {data?.current_state_residing || "-"}
                                    </div>
                                </div>

                                {/* Children Section */}
                                <div className="view-member-info-row">
                                    <div className="view-member-info-label">Children</div>
                                    <div className='view-member-arrow'>-</div>
                                    <div className="view-member-info-value siblings-list">
                                        {Array.isArray(data?.children) && data.children.length > 0
                                            ? (
                                                <ul className="siblings-ul">
                                                    {data.children.map((child, index) => {
                                                        const suffix = child?.suffix?.name || child?.suffix || "";
                                                        const displayName = child?.name || "-";
                                                        const formattedName = suffix 
                                                            ? `${displayName}, ${suffix}`
                                                            : `${displayName}`;
                                                        
                                                        return (
                                                            <li 
                                                                key={child?.id || index}
                                                                className="sibling-name-item"
                                                            >
                                                                {formattedName}
                                                            </li>
                                                        );
                                                    })}
                                                </ul>
                                            )
                                            : "-"}
                                    </div>
                                </div>

                                {/* Siblings Section */}
                                <div className="view-member-info-row">
                                    <div className="view-member-info-label">
                                        Sibling(s)
                                        <span style={{ color: '#999', fontSize: '12px', fontWeight: 'normal', display: 'block', marginTop: '4px' }}>
                                            the asterisk is where this family member is in the lineup by age order, from oldest to youngest.
                                        </span>
                                    </div>
                                    <div className='view-member-arrow'>-</div>
                                    <div className="view-member-info-value siblings-list">
                                        {Array.isArray(data?.siblings) && data.siblings.length > 0
                                            ? (() => {
                                                // Find the last non-asterisk item index
                                                let lastNonAsteriskIndex = -1;
                                                for (let i = data.siblings.length - 1; i >= 0; i--) {
                                                    if (!data.siblings[i]?.own) {
                                                        lastNonAsteriskIndex = i;
                                                        break;
                                                    }
                                                }
                                                
                                                return (
                                                    <ul className="siblings-ul">
                                                        {data.siblings.map((sibling, index) => {
                                                            if (sibling?.own) {
                                                                return (
                                                                    <li 
                                                                        key={sibling?.id || index}
                                                                        className="asterisk-item"
                                                                    >
                                                                        *
                                                                    </li>
                                                                );
                                                            }
                                                            
                                                            const suffix = sibling?.suffix?.name || sibling?.suffix || "";
                                                            const displayName = sibling?.name || "-";
                                                            const formattedName = suffix 
                                                                ? `${displayName}, ${suffix}`
                                                                : `${displayName}`;
                                                            
                                                            return (
                                                                <li 
                                                                    key={sibling?.id || index}
                                                                    className="sibling-name-item"
                                                                >
                                                                    {formattedName}
                                                                </li>
                                                            );
                                                        })}
                                                    </ul>
                                                );
                                            })()
                                            : "-"}
                                    </div>
                                </div>



                                {/* {
                                data?.marital_status != 1 && (
                                    <div className="view-member-info-row">
                                        <div className="view-member-info-label">Spouse</div>
                                        <div className='view-member-arrow'>-</div>
                                        <div className="view-member-info-value">
                                            {data?.spouse_first_name || data?.all_spouses?.[0]?.spouse_first_name || "-"}
                                        </div>
                                    </div>
                                )
                            } */}



                                {/* <div className="view-member-info-row">
                                <div className="view-member-info-label">Wedding Anniversary</div>
                                <div className='view-member-arrow'>-</div>
                                <div className="view-member-info-value">
                                    {
                                        data?.marital_status != "1" &&
                                        msToDate(data?.wedding_anniversary) || "-"
                                    }
                                </div>
                            </div> */}



                                {/* <div className="view-member-info-row">
                                <div className="view-member-info-label">Twin</div>
                                <div className='view-member-arrow'>-</div>
                                <div className="view-member-info-value">
                                    {data?.twin || ""}
                                </div>
                            </div> */}

                                <div className="view-member-info-row">
                                    <div className="view-member-info-label">Bio Descendant Parent(s)</div>
                                    <div className='view-member-arrow'>-</div>
                                    <div className="view-member-info-value">
                                        {data?.bio_descendant_parent || data?.User?.bio_descendant_parent || "-"}
                                    </div>
                                </div>

                                <div className="view-member-info-row">
                                    <div className="view-member-info-label">Bio Non-Descendant Parent</div>
                                    <div className='view-member-arrow'>-</div>
                                    <div className="view-member-info-value">
                                        {data?.bio_non_descendant_parent || data?.User?.bio_non_descendant_parent || "-"}
                                    </div>
                                </div>

                                <div className="view-member-info-row">
                                    <div className="view-member-info-label">Step Parent</div>
                                    <div className='view-member-arrow'>-</div>
                                    <div className="view-member-info-value">
                                        {data?.step_parent || data?.User?.step_parent || "-"}
                                    </div>
                                </div>

                                <div className="view-member-info-row">
                                    <div className="view-member-info-label">Adopted Parent(s)</div>
                                    <div className='view-member-arrow'>-</div>
                                    <div className="view-member-info-value">
                                        {data?.adopted_parent || data?.User?.adopted_parent || "-"}
                                    </div>
                                </div>


                                {/* Multiple marriages / spouses history */}
                                {
                                    Array.isArray(data?.all_spouses) && data.all_spouses.length > 0 && (
                                        <div className="view-member-marriages-section">
                                            {/* <div className="view-member-section-title">Marriages</div> */}
                                            {
                                                data.all_spouses.map((spouse, index) => (
                                                    <React.Fragment key={spouse?.relation_history_id || index}>
                                                        <div className="view-member-section-title">
                                                            {`Marriage ${index + 1}`}
                                                        </div>

                                                        <div className="view-member-info-row">
                                                            <div className="view-member-info-label">Spouse Name</div>
                                                            <div className='view-member-arrow'>-</div>
                                                            <div className="view-member-info-value">
                                                                {spouse?.spouse_full_name
                                                                    || [spouse?.spouse_first_name, spouse?.spouse_last_name]
                                                                        .filter(Boolean)
                                                                        .join(" ")
                                                                    || "-"}
                                                            </div>
                                                        </div>

                                                        <div className="view-member-info-row">
                                                            <div className="view-member-info-label">Wedding Anniversary</div>
                                                            <div className='view-member-arrow'>-</div>
                                                            <div className="view-member-info-value">
                                                                {spouse?.wedding_anniversary
                                                                    ? msToDate(spouse.wedding_anniversary)
                                                                    : "-"}
                                                            </div>
                                                        </div>

                                                        <div className="view-member-info-row">
                                                            <div className="view-member-info-label">Divorce Date</div>
                                                            <div className='view-member-arrow'>-</div>
                                                            <div className="view-member-info-value">
                                                                {spouse?.divorce_date
                                                                    ? msToDate(spouse.divorce_date)
                                                                    : "-"}
                                                            </div>
                                                        </div>
                                                    </React.Fragment>
                                                ))
                                            }
                                        </div>
                                    )
                                }




                                {/* Contact Information */}
                                <div className="view-member-section-title">Contact Info</div>



                                <div className="view-member-info-row">
                                    <div className="view-member-info-label">Cell Type</div>
                                    <div className='view-member-arrow'>-</div>
                                    <div className="view-member-info-value">
                                        {enums.cell_type[data?.User?.phone_type] || '-'}
                                    </div>
                                </div>

                                <div className="view-member-info-row">
                                    <div className="view-member-info-label">Cell Number</div>
                                    <div className='view-member-arrow'>-</div>
                                    <div className="view-member-info-value">
                                        {/* {data?.User?.country_code && data?.User?.phone_number
                                        ? `${data?.User?.country_code} ${data?.User?.phone_number}`
                                        : data?.User?.phone_number || '-'} */}
                                        {
                                            formatPhoneNumber(data?.User?.country_code, data?.User?.phone_number)
                                        }
                                    </div>
                                </div>





                                <div className="view-member-info-row">
                                    <div className="view-member-info-label">Email Address</div>
                                    <div className='view-member-arrow'>-</div>
                                    <div className="view-member-info-value">
                                        {data?.User?.email || "-"}
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div className="popup-actions addmember-actions">
                    <button
                        type="button"
                        onClick={onClose}
                        className="btn-outline"
                    >
                        Cancel
                    </button>
                    <button
                        type="submit"
                        // onClick={()=>{
                        //     onClose(); //close view modal
                        //     onEdit(memberData); //open edit modal
                        // }}
                        onClick={async (e) => {
                            e.preventDefault();
                            onClose();  // Close the view modal first

                            // Add a small delay before opening edit modal
                            await new Promise(resolve => setTimeout(resolve, 300));
                            const combinedData = {
                                ...memberData,
                                // custom:"hey"
                                userData: data
                            }
                            // onEdit(memberData);  // Then open edit modal
                            onEdit(combinedData);
                        }}
                        className="btn submit-btn"
                        style={{
                            backgroundColor: memberData?.colorCode || '#A6A6B5'
                        }}

                    >
                        Edit
                    </button>
                </div>
            </div>
        </ReactModal>
    );
};

export default ViewMemberModal;